export default __webpack_public_path__ + "static/cover-b7e435177a943d0b984bcea0c9e7fa21.png";